import {
  ChatWidgetText,
  isSafeWidgetUrl,
  OrderWidget,
} from "../../../Helper/ChatWidget";
import {
  Button,
  Card,
  Eyebrow,
  Foot,
  openWidgetUrl,
  Pill,
  Segments,
  Thumb,
} from "../ChatWidgetPrimitives";
import "./OrderCard.scss";

/** 12 Order: "Where is my order?" Arrival day, progress, carrier. */
export const OrderCard = ({
  widget,
  text,
}: {
  widget: OrderWidget;
  text: ChatWidgetText;
}) => {
  const items = widget.items ?? [];
  const label = text("widgetOrder", { number: widget.orderNumber });
  const progress = widget.progress;
  const hasItemsLine = items.length > 0 || !!widget.carrier;
  const hasTracking = isSafeWidgetUrl(widget.trackingUrl);
  return (
    <Card className="cw-order" label={label}>
      <div className="cw-pad">
        <div className="cw-row">
          <Eyebrow>{label}</Eyebrow>
          <Pill status={widget.status} />
        </div>
        <div className="cw-order-head">
          <div className="cw-h cw-h--xl">{widget.headline}</div>
          {widget.subline && (
            <div className="cw-muted cw-sm cw-num">{widget.subline}</div>
          )}
        </div>
        {progress && progress.steps?.length > 0 && (
          <Segments
            steps={progress.steps}
            current={progress.current}
            partial={progress.partial}
          />
        )}
      </div>
      {hasItemsLine && (
        <>
          <div className="cw-sep" />
          <div className="cw-line cw-order-line">
            {items.length > 0 && (
              <div className="cw-order-stack">
                {items.slice(0, 3).map((item, index) => (
                  <Thumb
                    key={index}
                    image={item.image}
                    size={36}
                    className="cw-order-thumb"
                  />
                ))}
              </div>
            )}
            <div className="cw-stack cw-grow">
              {items.length > 0 && (
                <span className="cw-medium">
                  {items.map((item) => item.title).join(", ")}
                </span>
              )}
              {widget.carrier && (
                <span className="cw-muted cw-sm cw-num">{widget.carrier}</span>
              )}
            </div>
          </div>
        </>
      )}
      {hasTracking && (
        <Foot flush={hasItemsLine}>
          <Button
            variant="ghost"
            onClick={() => openWidgetUrl(widget.trackingUrl)}
          >
            {text("widgetTrackPackage")}
          </Button>
        </Foot>
      )}
    </Card>
  );
};
